import { useEffect } from "react";

let locks = 0;
let savedOverflow = "";

/**
 * Keeps the page behind an overlay from scrolling while it is open (a wheel or
 * touch scroll inside a dialog must not move the document). Reference-counted,
 * so nested dialogs (modal + confirm) release the lock only when the last one
 * closes. Pass `false` to keep the hook mounted without locking.
 */
export function useScrollLock(active = true): void {
  useEffect(() => {
    if (!active) return;
    if (locks++ === 0) {
      savedOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    return () => {
      if (--locks === 0) document.body.style.overflow = savedOverflow;
    };
  }, [active]);
}
